import type { ReactNode } from 'react';
import { Skeleton } from '@london-life/ui/components/skeleton';

// one look for empty and loading views on every admin page
export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="admin-empty">
      <p className="admin-empty-title">{title}</p>
      {children}
    </div>
  );
}
export function LoadingState({ rows = 4 }: { rows?: number }) {
  return (
    <div className="admin-loading" aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="admin-loading-row" />
      ))}
    </div>
  );
}
